import React from 'react'
import Form from '../components/Form'

const ContactForm = () => {
  return (
    <div>
      <Form />
    </div>
  )
}

export default ContactForm
